var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case-detail"},_vm._l((_vm.caseDetailList),function(item){return _c('div',{ref:"main",refInFor:true,staticClass:"case-img"},[_c('van-image',{staticStyle:{"width":"100%"},attrs:{"src":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }